module.exports = __webpack_public_path__ + "static/media/pfbg_576.85341a9c.jpg";